export function Register() {
    return <div>
        Register
    </div>
}